import {
  Activity,
  BadgeCheck,
  Calendar,
  CalendarDays,
  ChartColumn,
  ChartNoAxesCombined,
  CircleAlert,
  CircleCheck,
  CircleHelp,
  CircleX,
  Clock,
  Flag,
  Gauge,
  Hourglass,
  Info,
  ShieldCheck,
  ThumbsDown,
  ThumbsUp,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
} from 'lucide-react';
import { MessagesCircleGlyph } from '../_glyphs/messages-circle';
import { createLucideIcon } from '../createLucideIcon';

// Status / feedback / time / analytics icons.
// GAP: Lucide is outline-only. MUI filled variants (CheckCircle, Error, Warning,
// ThumbUp/Down) collapse onto the same glyph as their Outlined counterparts.
export const CheckCircleIcon = /* #__PURE__ */ createLucideIcon('CheckCircle', CircleCheck);
export const CheckCircleOutlineIcon = /* #__PURE__ */ createLucideIcon('CheckCircleOutline', CircleCheck);
export const CancelOutlinedIcon = /* #__PURE__ */ createLucideIcon('CancelOutlined', CircleX);
// MUI's built-in Chip delete glyph; registered so theme defaults can swap it.
export const CancelIcon = /* #__PURE__ */ createLucideIcon('Cancel', CircleX);
export const ErrorIcon = /* #__PURE__ */ createLucideIcon('Error', CircleAlert);
export const ErrorOutlineIcon = /* #__PURE__ */ createLucideIcon('ErrorOutline', CircleAlert);
export const WarningIcon = /* #__PURE__ */ createLucideIcon('Warning', TriangleAlert);
export const WarningAmberIcon = /* #__PURE__ */ createLucideIcon('WarningAmber', TriangleAlert);
export const InfoOutlinedIcon = /* #__PURE__ */ createLucideIcon('InfoOutlined', Info);
export const HelpOutlineIcon = /* #__PURE__ */ createLucideIcon('HelpOutline', CircleHelp);
export const VerifiedIcon = /* #__PURE__ */ createLucideIcon('Verified', BadgeCheck);
export const VerifiedUserIcon = /* #__PURE__ */ createLucideIcon('VerifiedUser', ShieldCheck);
export const FlagIcon = /* #__PURE__ */ createLucideIcon('Flag', Flag);
// Thumbs are used as a selected/unselected pair (MessageFeedback), so the
// "filled" MUI names paint the silhouette to keep the state cue visible.
export const ThumbUpIcon = /* #__PURE__ */ createLucideIcon('ThumbUp', ThumbsUp, { filled: true });
export const ThumbUpOutlinedIcon = /* #__PURE__ */ createLucideIcon('ThumbUpOutlined', ThumbsUp);
export const ThumbDownIcon = /* #__PURE__ */ createLucideIcon('ThumbDown', ThumbsDown, {
  filled: true,
});
export const ThumbDownOutlinedIcon = /* #__PURE__ */ createLucideIcon('ThumbDownOutlined', ThumbsDown);
export const RadioButtonCheckedIcon = /* #__PURE__ */ createLucideIcon(
  'RadioButtonChecked',
  MessagesCircleGlyph,
);
export const HourglassEmptyIcon = /* #__PURE__ */ createLucideIcon('HourglassEmpty', Hourglass);
export const SpeedIcon = /* #__PURE__ */ createLucideIcon('Speed', Gauge);
export const InsightsIcon = /* #__PURE__ */ createLucideIcon('Insights', ChartNoAxesCombined);
export const BarChartIcon = /* #__PURE__ */ createLucideIcon('BarChart', ChartColumn);
export const TimelineIcon = /* #__PURE__ */ createLucideIcon('Timeline', Activity);
export const TrendingUpIcon = /* #__PURE__ */ createLucideIcon('TrendingUp', TrendingUp);
export const TrendingDownIcon = /* #__PURE__ */ createLucideIcon('TrendingDown', TrendingDown);
export const ScheduleIcon = /* #__PURE__ */ createLucideIcon('Schedule', Clock);
export const AccessTimeIcon = /* #__PURE__ */ createLucideIcon('AccessTime', Clock);
export const CalendarTodayIcon = /* #__PURE__ */ createLucideIcon('CalendarToday', Calendar);
export const CalendarTodayOutlinedIcon = /* #__PURE__ */ createLucideIcon('CalendarTodayOutlined', Calendar);
export const CalendarMonthIcon = /* #__PURE__ */ createLucideIcon('CalendarMonth', CalendarDays);
